const d3 = require('d3')
const moment = require('moment');
const { parseDate } = require('../utils/formatters.js');
const { wrap } = require( '../utils/shared-functions.js');

const DEVICE_COLOR = '#000';
const EMPTY_COLOR = '#000000';
const MAX_PWV = 10;
const MIN_PWV = 0;
const margin = { top: 40, right: 30, bottom: 40, left: 50 };

exports.createPWVChart = function (rawData, thresholds, onClick, width, height) {

  const data = rawData.map((d, i) => {
      const date = parseDate(moment(d['date']).format('YYYY-MM-DD'));
      const { high, low, avg } = d;

      let color = DEVICE_COLOR;
      const empty = !avg;
      return { date, high, low, avg: +avg?.toFixed(1), color, empty};
    });

  const x = d3
    .scaleBand()
    .domain(d3.utcDay.range(data[0].date, +data[data.length - 1].date + 1))
    .range([margin.left, width - margin.right])
    .padding(0.4);

  const y = d3
    .scaleLinear()
    .domain([MIN_PWV, MAX_PWV])
    .nice()
    .range([height - margin.bottom, margin.top]);
  
  const xAxis = (g) =>
    g.attr('transform', `translate(0,${height - margin.bottom - 2})`)
      .call(d3.axisBottom(x)
          .tickValues(d3.utcDay.every(1).range(data[0].date, +data[data.length - 1].date + 1))
          .tickFormat((d) =>  moment(d).format('ddd DD'))
          .tickSize(0)
      )
      .call((g) =>
        g.selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('transform', `translate(0,${-height + margin.top + margin.bottom + 3})`)
          .attr('y2', height - margin.top - margin.bottom)
      )
      .call((g) => g.select('.domain').remove());

  const yAxis = (g) =>
    g
      .attr('transform', `translate(${margin.left - 10},0)`)
      .call(d3
          .axisLeft(y)
          .tickValues(d3.scaleLinear().domain(y.domain()).ticks())
          .tickSize(0)
          .tickPadding(10)
      )
      .call((g) =>
          g.selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('x2', width - margin.left - margin.right)
      )
      .call((g) => g.select('.domain').remove());

  const oxygenLineGenerate = d3
    .line()
    .curve(d3.curveBumpX)
    .defined((d) => d.avg)
    .x((d) => x(d.date))
    .y((d) => y(d.avg));

  const svg = d3
    .create('svg')
    .attr('width', width)
    .attr('height', height);

  const oxygenLine = svg
    .append('path')
    .attr('d', oxygenLineGenerate(data))
    .attr('fill', 'none')
    .attr('transform', (d) => `translate(10,0)`)
    .attr('stroke', 'black');

  svg.append('g').call(xAxis).selectAll('.tick text').call(wrap, x.bandwidth());

  svg.append('g').call(yAxis);

  const yAxisLabelDate = svg
    .append('text')
    .attr('x', margin.left - 40)
    .attr('y', margin.top - 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('m/sec');

  const xAxisLabelDate = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('Date');

  const xAxisLabelDay = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 33)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text('Day')
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));

  const fixLabelXPosition = width / data.length / 3.7
  const g = svg
    .append('g')
    .selectAll('g')
    .data(data)
    .join('g')
    .attr('transform', (d) => `translate(${x(d.date) + fixLabelXPosition},0)`);

  const emptyGroup = g.append('g').attr('visibility', (d) => {
    return d.empty ? 'visible' : 'hidden';
  });

  const emptyBar = emptyGroup
    .append('line')
    .attr('y1', (d) => y(MIN_PWV))
    .attr('y2', (d) => y(MAX_PWV))
    .attr('stroke-width', 35)
    .attr('stroke', (d) => EMPTY_COLOR)
    .attr('opacity', 0.07);

  const oxygenCandleGroup = g.append('g').filter((d) => d.avg);
 
  const oxygenCircle = oxygenCandleGroup
    .append('circle')
    .attr('r', 10)
    .attr('cy', (d) => y(d.avg))
    .attr('stroke-width', 1)
    .attr('fill', 'white')
    .attr('stroke', (d) => d.color)
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));

  const oxygenCircleText = oxygenCandleGroup
    .append('text')
    .attr('text-anchor', 'middle')
    .attr('dy', (d) => y(d.avg) + 5)
    .style('font-size', '11px')
    .attr('font-weight', '400')
    .append('tspan')
    .attr('font-family', 'roboto')
    .text((d) => d.avg)
    .style("cursor", "pointer")
    .on("click", (e, d) => onClick(d.date));

  return svg.node();
};

